import {CATEGORIES_LOAD} from "./modules/categories";
import {DOCUMENTS_LOAD} from "./modules/documents";
import {LIGHTBOX_SET_MEDIA, LIGHTBOX_SET_VISIBLE} from "./mutations";

export const LIGHTBOX_OPEN = 'LIGHTBOX_OPEN'
export const INITIAL_LOAD = 'INITIAL_LOAD'

export default {

    [INITIAL_LOAD]({dispatch}) {
        dispatch(CATEGORIES_LOAD);
        dispatch(DOCUMENTS_LOAD, {
            mode: 'all',
            filter: {}
        })
    },

    [LIGHTBOX_OPEN]({commit}, media) {
        if (window.location !== window.parent.location) {
            window.parent.postMessage({
                action: 'lightbox',
                media
            }, '*')

            return;
        }
        console.log('lopp');
        commit(LIGHTBOX_SET_VISIBLE, true);
        commit(LIGHTBOX_SET_MEDIA, media);
    }


}